var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"ml-2",attrs:{"disabled":!_vm.isRoleUser,"bottom":""}},[_c('template',{slot:"activator"},[_vm._t("default",null,{"isDisabledForUser":_vm.isRoleUser})],2),_c('span',[_vm._v(_vm._s(_vm.$t('pleaseSignUp')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }